import React, { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { UserStateComponent } from './UserState';
import { useAuthUser } from '../auth';

export const NavMenu = () => {
    const { checkRole, isAuthentificated } = useAuthUser();
    const [collapsed, setCollapsed] = useState();

    const toggleNavbar = () => setCollapsed(!collapsed);

    var configLinks = <></>

    if (checkRole('Pocahontas_Config')) {
        configLinks = <UncontrolledDropdown
                className="me-2"
                direction="down"
            >
                <DropdownToggle
                    caret
                    color="white"
                >
                    Config
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem>
                    <NavItem><NavLink tag={Link} className="text-dark" to="/config/activite">Activité</NavLink> </NavItem>                    
                </DropdownItem>
                <DropdownItem>
                    <NavItem><NavLink tag={Link} className="text-dark" to="/config/activiteassociee">Activité associée</NavLink> </NavItem>
                </DropdownItem>
                <DropdownItem>
                    <NavItem><NavLink tag={Link} className="text-dark" to="/config/competencedeterminante">Compétence Déterminante</NavLink> </NavItem>
                </DropdownItem>
                <DropdownItem>
                    <NavItem><NavLink tag={Link} className="text-dark" to="/config/competencebloquante">Compétence Bloquante</NavLink> </NavItem>
                </DropdownItem>
                <DropdownItem>
                    <NavItem><NavLink tag={Link} className="text-dark" to="/config/competenceprincipale">Compétence Principale</NavLink> </NavItem>
                </DropdownItem>
            <DropdownItem>
                <NavItem><NavLink tag={Link} className="text-dark" to="/config/competenceliee">Compétence Liée</NavLink> </NavItem>
                </DropdownItem>
        </DropdownMenu>
            </UncontrolledDropdown>
    }

    var constantesConfigLinks = <></>
    if (checkRole("Pocahontas_ConstantesConfig")) {
        constantesConfigLinks = <UncontrolledDropdown
            className="me-2"
            direction="down"
        >
            <DropdownToggle
                caret
                color="white"
            >
                Constante Config
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem>
                    <NavItem><NavLink tag={Link} className="text-dark" to="/constantesconfig/matchage">Matchage</NavLink> </NavItem>
                </DropdownItem>
                <NavItem><NavLink tag={Link} className="text-dark" to="/constantesconfig/scoring">Scoring</NavLink> </NavItem>
                <DropdownItem>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    }


    var wordingRoles = <></>
    if (checkRole('Pocahontas_Wording')) {
        wordingRoles = <NavItem>
            <ul className="dropdown-menu">
                <li className="dropdown-item"><NavLink tag={Link} className="text-dark" to="/wording/activite">Activité Wording</NavLink></li>
                <li className="dropdown-item"><NavLink tag={Link} className="text-dark" to="/wording/competence">Compétence Wording</NavLink></li>
                <li className="dropdown-item"><NavLink tag={Link} className="text-dark" to="/wording/additionaldata">Additional Data Wording</NavLink></li>
            </ul>
            <UncontrolledDropdown
                className="me-2"
                direction="down"
            >
                <DropdownToggle
                    caret
                    color="white"
                >
                    Wording
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem>
                        <NavLink tag={Link} className="text-dark" to="/wording/activite">Activité Wording</NavLink>
                    </DropdownItem>
                    <DropdownItem >
                        <NavLink tag={Link} className="text-dark" to="/wording/competence">Compétence Wording</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                        <NavLink tag={Link} className="text-dark" to="/wording/additionaldata">Additional Data Wording</NavLink>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </NavItem>
    }

    var createRunAOLink = <></>
    if (checkRole('Pocahontas_CreateRunAos')) {
        createRunAOLink = <DropdownItem >
            <NavLink tag={Link} className="text-dark" to="/aos/create">Créer un run d'AO</NavLink>
        </DropdownItem>
    }

    var feedbackLink = <></>
    if (checkRole('Pocahontas_Feedback')) {
        feedbackLink = <DropdownItem >
            <NavLink tag={Link} className="text-dark" to="/aos/feedback">Feedbacks</NavLink>
        </DropdownItem>
    }


    var monitoringPageLink = <></>
    if (checkRole('Pocahontas_Monitoring'))
    {
        monitoringPageLink = <DropdownItem>
            <NavLink tag={Link} className="text-dark" to="/Monitoring">Monitoring</NavLink>
        </DropdownItem>
    }

    var dailyJobLinks = <></>
    if (checkRole('Pocahontas_DailyJob')) {
        dailyJobLinks = <><DropdownItem>
            <NavLink tag={Link} className="text-dark" to="/dailyjobs">Daily Jobs</NavLink>
        </DropdownItem>
            <DropdownItem>
                <NavLink tag={Link} className="text-dark" to="/loadintercontrats">Charger les intercontrats</NavLink>
            </DropdownItem>
        </>
    }

    var callHistoryLinks = <></>
    if (checkRole('Pocahontas_CallHistory')) {
        callHistoryLinks = 
            <DropdownItem>
                <NavLink tag={Link} className="text-dark" to="/callHistory">Historique des appels</NavLink>
            </DropdownItem>
    }

    var monitoringLink = <></>
    if (checkRole('Pocahontas_Monitoring') || checkRole('Pocahontas_DailyJob') || checkRole('Pocahontas_CallHistory') ){
        monitoringLink = <UncontrolledDropdown
            className="me-2"
            direction="down"
        >
            <DropdownToggle
                caret
                color="white"
            >
                Jobs
            </DropdownToggle>
            <DropdownMenu>
                {monitoringPageLink}
                {dailyJobLinks}
                {callHistoryLinks }
            </DropdownMenu>
        </UncontrolledDropdown>

    }

    var info = <></>
    if (checkRole('Pocahontas_CompetenceSimilaire')) {
        info = <NavItem>
            <UncontrolledDropdown
                className="me-2"
                direction="down"
            >
                <DropdownToggle
                    caret
                    color="white"
                >
                    Info
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem>
                        <NavLink tag={Link} className="text-dark" to="/info/competencesimilaires">Compétences similaires</NavLink>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </NavItem>
    }

    var calculatedCv = <></>;
    if (checkRole("Pocahontas_CalculateCv") || checkRole("Pocahontas_MissingCompetence") ) {
        calculatedCv = <NavItem><UncontrolledDropdown
            className="me-2"
            direction="down"
        >
            <DropdownToggle
                caret
                color="white"
            >
                Calcul sur le cv
            </DropdownToggle>
            <DropdownMenu>
                {checkRole("Pocahontas_CalculateCv") ? <DropdownItem><NavLink tag={Link} className="text-dark" to="/calculatedcv">Cv Calculés</NavLink></DropdownItem> : <></>}
                {checkRole("Pocahontas_MissingCompetence") ? <DropdownItem><NavLink tag={Link} className="text-dark" to="/missingcompetence">Compétences en trop</NavLink></DropdownItem> : <></>}
            </DropdownMenu>
        </UncontrolledDropdown>
            </NavItem>
    }

    return <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 " container light>
            <NavbarBrand className="text-primary" tag={Link} to="/">Pocahontas</NavbarBrand>
            <NavbarToggler onClick={toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={collapsed} navbar>
                <ul className="navbar-nav flex-grow">
                    { isAuthentificated() ? <>
                    <NavItem>
                        <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                    </NavItem>
                    {info }
                    <NavItem>
                        <UncontrolledDropdown
                            className="me-2"
                            direction="down"
                        >
                            <DropdownToggle
                                caret
                                color="white"
                            >
                                AOs
                            </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem>
                                        <NavLink tag={Link} className="text-dark" to="/aos/ondemand">Rechercher un profil</NavLink>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <NavLink tag={Link} className="text-dark" to="/aos/readmatch">Analyser un AO</NavLink>
                                    </DropdownItem>
                                    {createRunAOLink}
                                    <DropdownItem>
                                    <NavLink tag={Link} className="text-dark" to="/aos">Consulter les run d'AO</NavLink>
                                </DropdownItem>

                                { feedbackLink }
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </NavItem>
                    {calculatedCv}
                    {configLinks}
                    {constantesConfigLinks }
                    {wordingRoles}
                    {monitoringLink }
                    <NavItem><UserStateComponent /></NavItem>
                    </> : <></> }
                    </ul>
            </Collapse>

        </Navbar>
    </header>
}